import CheckboxButton from './BaseCheckboxButton';
import withLabel from '../Form/withLabel';
/**
 * 带文字的复选框组件。
 */
// tslint:disable-next-line:no-any
var Checkbox = withLabel('Checkbox')(CheckboxButton);
Checkbox.displayName = 'Checkbox';
export default Checkbox;
//# sourceMappingURL=Checkbox.js.map